import capitalize from 'lodash/capitalize';

import { LibraryFilter } from '@/enums/LibraryFilter';

export const generateFilterChips = (
  filtersObj,
  selectedConference,
  selectedSubject,
  selectedEvent,
  allTagsData,
  allLecturePackages
) => {
  return Object.entries(filtersObj).reduce((acc, iter: [string, string]) => {
    const [key, value] = iter;

    if (key === LibraryFilter.Publisher) {
      if (!selectedConference) {
        return acc;
      }
      return [...acc, { key, value, label: selectedConference?.extendedName || value }];
    }

    if (key === LibraryFilter.Event) {
      if (!selectedEvent) {
        return acc;
      }
      return [...acc, { key, value, label: selectedEvent?.name }];
    }

    if (key === LibraryFilter.Subject) {
      if (!selectedSubject) {
        return acc;
      }
      const subjectCategoriesArray = selectedSubject?.fullName.split('/');
      const lastSubject = subjectCategoriesArray?.pop();

      return [...acc, { key, value, label: lastSubject || value }];
    }

    const arrayValue = value.split(',');

    if (key === LibraryFilter.Tag) {
      if (!allTagsData) {
        return acc;
      }

      const tagMap = allTagsData?.reduce((tags, tag) => {
        return { ...tags, [tag.id]: capitalize(tag.name) };
      }, {});

      return [
        ...acc,
        ...arrayValue.map((item) => {
          return { key, value: item, label: tagMap?.[item] };
        }),
      ];
    }

    if (key === LibraryFilter.Year) {
      return [
        ...acc,
        ...arrayValue.map((item) => {
          return { key, value: item, label: item };
        }),
      ];
    }

    if (key === LibraryFilter.YearStartsAt) {
      return [
        ...acc,
        ...arrayValue.map((item) => {
          return { key, value: item, label: item };
        }),
      ];
    }

    if (key === LibraryFilter.Package) {
      if (!allLecturePackages) {
        return acc;
      }

      const packagesMap = allLecturePackages?.reduce((packages, packageData) => {
        return { ...packages, [packageData.name]: packageData.label };
      }, {});

      return [
        ...acc,
        ...arrayValue.map((item) => {
          return { key, value: item, label: packagesMap?.[item] };
        }),
      ];
    }

    throw new Error();
  }, []);
};
